import { SERVER_URL } from './constants';

/**
 * The backend's own answer to "what are you running". Null on any failure —
 * callers treat an unknown backend version as "don't claim skew", because a
 * network blip must not produce a warning that looks like a bad deploy.
 */
export async function fetchBackendVersion() {
  try {
    const token = sessionStorage.getItem('bearer') || localStorage.getItem('bearer');
    const res = await fetch(`${SERVER_URL}api/version`, {
      cache: 'no-store',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
